'use client';

import Link, { LinkProps } from 'next/link';
import { Icon, IconName, Intent } from '@blueprintjs/core';
import { AnchorHTMLAttributes, ReactNode } from 'react';

type Props = LinkProps & AnchorHTMLAttributes<HTMLAnchorElement> & {
    minimal?: boolean
    icon?: IconName;
    children?: ReactNode;
    intent?: Intent;
}

export default function SAnchorButton(props: Props) {
    const {minimal, icon, children, intent} = props;
    let kids = <>{children}</>
    if (icon) {
        kids = <>
            <Icon icon={icon}/>
            {children}
        </>;
    }
    const classes = ['bp5-button'];
    if (minimal) {
        classes.push('bp5-minimal');
    }

    if (intent) {
        classes.push(`bp5-intent-${intent}`);
    }

    props = {...props, minimal: undefined, icon: undefined, children: undefined};
    return <Link
        {...props}
        className={classes.join(' ')}
        >
            {kids}
        </Link>
}
